import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {ToastrService} from 'ngx-toastr';
import {filter, map} from 'rxjs/operators';
import {combineLatest} from 'rxjs';
import {Router} from "@angular/router";
import {BlockBaseComponent} from "../block-base/block-base.component";
import {ContainerService, SceneService, StoreSelectorsService} from "../../../../services";
import {IButtonBar} from "../../../../components/add-remove-bar/button-bar.component";
import {ITableListColumn, ITableListEvent} from "../../../../components/table-list-input/table-list-input.component";
import {actionSceneItemPlaylist, actionSceneJumpLinked} from "../../../../store/actions/user.actions";
import {compareIds, getTotalLengthPlaylist, isNullOrUndef, MAX_PLAYLIST_TIME} from "../../../../common";
import {faCrosshairs, faImage, faPlayCircle, IconDefinition} from "@fortawesome/free-solid-svg-icons";
import {ITableIconPipe} from "../../../../pipes/table-list-icon-pipe";
import {Memoizee} from "../../../../decorators/memoizee-decorator";
import {Lib} from "../../../../../libs/Lib";
import * as _ from "lodash";

@Component({
    selector: 'app-block-playlist',
    templateUrl: './block-playlist.component.html',
    styleUrls: ['./block-playlist.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlockPlaylistComponent extends BlockBaseComponent {

    buttons: IButtonBar[] = [];
    tableColumns: Array<ITableListColumn> = [];

    constructor(
        private translocoService: TranslocoService,
        public override storeSelector: StoreSelectorsService,
        private containerService: ContainerService,
        private sceneService: SceneService,
        private toastr: ToastrService,
        public override dialog: MatDialog,
        public cd: ChangeDetectorRef,
        private router: Router
    ) {
        super(storeSelector, dialog);
        this.tableColumns = [
            {
                inputType: 'text',
                name: 'page',
                maxStringSize: '20'
            },
            // {
            //     inputType: 'text',
            //     name: 'type',
            //     maxStringSize: '14'
            // },
            {
                inputType: 'number',
                name: 'duration',
                maxStringSize: '12'
            }
        ];
        
        this.buttons = [
            {
                callBack: v => (v),
                icon: 'settings_overscan',
                name: 'list',
                disableByList: false,
                disabled: false,
                tooltip: this.translocoService.translate('general.expandPlaylist', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'add',
                name: 'add',
                disableByList: false,
                disabled: false,
                tooltip: this.translocoService.translate('general.addContent', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'link',
                name: 'link',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.jumpToItem', {}, this.translocoService.getActiveLang()),
            },
            {
                callBack: v => (v),
                icon: 'remove',
                name: 'remove',
                disableByList: true,
                confirmRemove: this.translocoService.translate('toast.deleteConfirm', {}, this.translocoService.getActiveLang()),
                disabled: false,
                tooltip: this.translocoService.translate('general.remove', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'arrow_left',
                name: 'previous',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.next', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'arrow_right',
                name: 'next',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.previous', {}, this.translocoService.getActiveLang())
            }
        ];
    }

    onPlaylistTimeline() {
        this.containerService.updateEditorMode('playlistMode');
    }

    override componentInit() {
        super.componentInit();
        const playlistIndexes$ = this.storeSelector.listenSelectedScenePlaylist();
        const sceneUpdate$ = this.storeSelector.listenPlayersOfScene(this.sceneId);
        this.cod(
            combineLatest([playlistIndexes$, sceneUpdate$]).pipe(
                map(([indexes, sceneUpdate]) => {
                    return indexes;
                }),
                filter((v) => v !== null)
            ).subscribe((indexes) => {
                super.initApplyStoreToDynamic(true);
                if (!this.dynamicsInitialized) {
                    setTimeout(() => {
                        this.tableListSelection('Page', indexes);
                    }, 333);
                } else {
                    this.tableListSelection('Page', indexes);
                }
                this.cd.markForCheck();
            })
        );
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
        // super.initApplyStoreToDynamic(true);
        this.cd.markForCheck();
    }

    updateTransition() {

    }

    private onTableListChangeCallBack(e: ITableListEvent) {
        if (e.currentAction === 'selected') {
            this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: e.selectedIndexes}));

        } else if (e.currentAction === 'previous' || e.currentAction === 'next') {
            // this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: e.selectedIndexes}));

        } else if (e.currentAction === 'link') {
            this.jumpToPlayer(e.selected[0]);
            this.dialog.closeAll();

        } else if (e.currentAction === 'rename') {
            const oldPages = this.sceneItem.Data[0].Playlist[0].Page;
            let newPages = e.values;
            if (newPages && _.isArray(newPages)) {
                const len = getTotalLengthPlaylist(newPages);
                if (len > MAX_PLAYLIST_TIME) {
                    this.sceneService.showToastOverLength();
                    // this.storeSelector.dispatch({type: 'UNDO'});
                    newPages = oldPages;
                }
                this.dispatchSceneItemChanges({
                    sceneId: this.sceneId,
                    sceneItemId: this.sceneItem.$.id,
                    values: [{
                        key: 'Page',
                        value: newPages,
                        storePath: 'Data[0].Playlist[0]'
                    }]
                });
                super.initApplyStoreToDynamic(true);
            }

        } else if (e.currentAction === 'drop' || e.currentAction === 'removed') {
            this.dispatchSceneItemChanges({
                sceneId: this.sceneId,
                sceneItemId: this.sceneItem.$.id,
                values: [{
                    key: 'Page',
                    value: e.values,
                    storePath: 'Data[0].Playlist[0]'
                }]
            });
            if (e.currentAction === 'removed') {
                this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: []}));
            }
        } else if (e.currentAction === 'list') {
            this.onPlaylistTimeline();
        } else if (e.currentAction === 'added') {
            this.sceneService.openPlaylistAssociateDialog(this.sceneItem, true, 'Page');
            this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: []}));
        }
    }

    @Memoizee({})
    onCallBackIcon(v: ITableIconPipe): IconDefinition {
        if (v.index === 0) {
            if (v.params.$.type === "scene") {
                return faCrosshairs;
            } else {
                if (compareIds(v.params.Player[0]?.$.player, '3100')) {
                    return faPlayCircle;
                }
                return faImage;
            }
        }
        return null;
    }

    override submit(formValues) {
        super.submit(formValues);
        // if (this.onFormSubmitAction(formValues)) {
        //     super.submit(formValues);
        // }
    }

    jumpToPlayer(item) {
        const itemType = item?.$?.type;
        if (!item || !itemType) return;

        if (itemType === 'scene') {
            const src = item?.Player[0]?.$?.src;
            if (!src) return;

            this.storeSelector.dispatch(actionSceneJumpLinked({previousLinkedSceneId: this.sceneId}));
            this.containerService.updateEditorMode(null);
            this.router.navigateByUrl(`/editor/scene/${src}`);
        } else {
            this.router.navigateByUrl(`/resources/list?filter=${item.$.page}`);
        }
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.playlistName', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "label",
                storePath: '$.label'
            },
            {
                type: "input",
                value: '',
                min: '1',
                max: '999',
                minMaxDefault: '5',
                label: this.translocoService.translate('general.newResourceDefaultDuration', {}, this.translocoService.getActiveLang()),
                inputType: "number",
                name: "duration",
                storePath: 'Data[0].Playlist[0].$.duration'
            },
            // {
            //     type: "checkbox",
            //     value: '1',
            //     label: this.translocoService.translate('general.gpu', {}, this.translocoService.getActiveLang()),
            //     name: "gpu",
            //     storePath: '$.gpu'
            // },
            {
                type: "input",
                label: '',
                inputType: 'tablelist',
                tableColumns: this.tableColumns,
                ignoreMissingValue: true,
                cloneVals: true,
                multiSelect: false,
                rememberSelection: true,
                allowFilter: true,
                buttonBarClassName: 'playlistButtonBar',
                buttons: this.buttons,
                inputEditFormat: {page: 'text', duration: 'number'},
                requiredFields: {page: true, duration: false},
                inputEditRenamePath: [{path: '$.page', key: 'page'}, {path: '$.duration', key: 'duration'}],
                name: "Page",
                storePath: 'Data[0].Playlist[0].Page',
                expandableEditor: true,
                enablePagination: true,
                allowTableOnDialog: true,
                disableSubmit: true,
                callBackEvent: (v) => this.onTableListChangeCallBack(v),
                callBackFaIcon: (v) => this.onCallBackIcon(v)
                // callBackFaIcon: (v) => BlockPlaylistComponent.onCallBackFaIcon(v),
            }
        ];
        // this.uiConfigInit = this.appendGpu(this.uiConfigInit);
    }
}

